import { Plan, useCurrentUser, useCurrentAgreement } from '@economic/react-app';
import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';
import EditCompanyInfoDialog from '~/app/pages/settings/master-information/dialogs/EditCompanyInfoDialog';
import { isCvrReadonly } from '~/app/pages/settings/master-information/sections/CompanyInfo';
import type { CompanyResponse } from '~/payment-cards-feature';

export const CompanySettingsButton = ({
    onSettingsSaved,
    currentCompanyData,
}: {
    onSettingsSaved: () => void;
    currentCompanyData: CompanyResponse;
}) => {
    const user = useCurrentUser();
    const { number: agreementNumber, subscription } = useCurrentAgreement();
    const isAdministrator = user.isAdministrator && agreementNumber === user.agreement.number;
    const isInternalAgreement = subscription.level === Plan.Internal;

    return (
        <Button
            appearance="primary"
            dialog={dialogProps => (
                <EditCompanyInfoDialog
                    {...dialogProps}
                    initialData={currentCompanyData?.model}
                    onSubmitted={() => {
                        onSettingsSaved();
                    }}
                    isAdministrator={isAdministrator}
                    isCvrReadonly={isCvrReadonly(currentCompanyData?.model, currentCompanyData?.model?.cvr, subscription)}
                    isInternalAgreement={isInternalAgreement}
                    isAdministratorPayingForCurrentAgreement={currentCompanyData?.isAdministratorPayingForCurrentAgreement}
                    enforce2FAReason={currentCompanyData?.enforce2FAReason}
                    shouldDisable2FA={currentCompanyData?.shouldDisable2FA}
                />
            )}>
            <Trans>Go to company settings</Trans>
        </Button>
    );
};
